import {TAppDispatch, TRootState} from "types";
import {buildCandidateApiRequestPayload} from "helpers/filterHandlers";
import {additionalProfileFiltersSelector} from "store/additional-profiles/additionalProfilesSelectors";
import {globalPerPageSelector} from "store/userPreference/userPreferenceSelectors";
import {
	fetchProjectCandidateIDs,
	getPaginatedProjectSavedPeople,
} from "store/project/projectCandidatesAsyncActions";

/**
 * An edited verdict can move a person in or out of an active Fit to Brief filter, so the list
 * and the filtered IDs are fetched again from page 1, as the filter panel does on any change:
 * the current page may no longer exist.
 */
export const refreshSavedPeopleFilteredByFitToBrief =
	() => (dispatch: TAppDispatch, getState: () => TRootState) => {
		const state = getState();
		const filters = additionalProfileFiltersSelector(state);

		if (!filters.fit_to_brief) return;

		dispatch(getPaginatedProjectSavedPeople({page: 1, per_page: globalPerPageSelector(state)}));
		dispatch(
			fetchProjectCandidateIDs(buildCandidateApiRequestPayload({...filters}, true)?.filters),
		);
	};
